module.exports = __webpack_public_path__ + "img/show_tc_text_11.94827b37.png";